import React from "react";
import withProviders from "../../../hooks/withProviders";
import { GenericLayoutPageSubHeader, Main } from "../../../components/utilities";
import { MicroserviceManagementProvider, MicroserviceActionsDropdown, MicroserviceStatusDisplay } from "../../../features/microservicemanagement";

export const AssetManagementMicroserviceManagementPage = withProviders([
    MicroserviceManagementProvider, { 
        healthEndpoint: '/api/assets/health',
        seedEndpoint: '/api/assets/system/jobs/seeding' 
    }
])(() => (
    <Main className="d-flex flex-column">
        <GenericLayoutPageSubHeader>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <MicroserviceStatusDisplay />
                </div>
                <div className="d-flex flex-fill justify-content-end align-items-center">
                    <MicroserviceActionsDropdown />
                </div>
            </div>
        </GenericLayoutPageSubHeader>
        <section className="px-4 my-3 h-100">
            <p>Asset Management</p>
        </section>
    </Main>
))